<template>
  <div>
    <!------------ start toast / snackbar ------------------------------>
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!------------ end toast / snackbar ------------------------------>
    <div>
      <!------------- section one--------------------->
      <v-row class="d-flex justify-space-between" flat>
        <v-col cols="12" md="4">
          <h1 class="heading-1">Blog</h1>
        </v-col>

        <!----------------------Blog organizer model-------------------------------->
        <v-col cols="12" md="8">
          <div class="d-flex justify-end pb-2">
            <v-card flat class="d-flex align-center">
              <v-dialog
                v-model="BlogOrganizeM"
                v-if="BlogOrganizeM"
                persistent
                content-class="elevation-0"
                max-width="1250"
              >
                <div
                  class="d-flex justify-space-between Organize_dialog_parent"
                >
                  <v-row>
                    <v-col cols="12" md="6" class="Organize_dialog_one">
                      <v-card flat>
                        <div class="mx-6 py-5 d-flex justify-space-between">
                          <span class="heading-2"> <b> Organize</b></span>
                          <div>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="#4B9ED6"
                                  class="mr-3"
                                  dark
                                  @click="TooltipInformationDialog = true"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-information
                                </v-icon>
                              </template>
                              <span>Information</span>
                            </v-tooltip>

                            <v-icon @click="BlogOrganizeM = false"
                              >mdi-close</v-icon
                            >
                          </div>
                        </div>
                        <organizeblog-1-component
                          @CloseOrganizeBlogs="CloseOrganizeBlogs"
                        />
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="6" class="Organize_dialog_two">
                      <v-card
                        flat
                        width="600"
                        class="pb-7"
                        style="height: fit-content"
                      >
                        <organizeblog-2-component />
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-dialog>
            </v-card>
            <v-card flat class="d-flex align-center add_orgranize_btn_destop">
              <v-btn
                @click.stop="BlogOrganizeM = true"
                color="primary"
                outlined
                depressed
                dark
                v-if="Permission.Add"
                class="text_style mr-3 px-8"
              >
                Organize
              </v-btn>
              <v-btn
                color="primary"
                depressed
                v-if="Permission.Add"
                dark
                class="text_style link_hover"
                @click="AddBlog"
              >
                + Add New Article
              </v-btn>
            </v-card>
          </div>
          <div class="add_orgranize_btn_mobile">
            <v-row>
              <v-col cols="12">
                <v-btn
                  @click.stop="BlogOrganizeM = true"
                  color="primary"
                  outlined
                  depressed
                  dark
                  block
                  class="text_style"
                  v-if="Permission.Add"
                >
                  Organize
                </v-btn></v-col
              >
              <v-col cols="12">
                <v-btn
                  color="primary"
                  depressed
                  block
                  dark
                  class="text_style link_hover"
                  @click="AddBlog"
                  v-if="Permission.Add"
                >
                  + Add New Article
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
    <!------------- section two--------------------->
    <div class="my-3">
      <v-row class="mt-6">
        <v-col cols="12" md="4" sm="6">
          <v-card flat>
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              hide-details
              single-line
              @input="searchData()"
            >
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <v-card
            height="45"
            outlined
            class="px-2 mt-n1 d-flex justify-start align-center"
            style="cursor: pointer"
            @click="filterDialog = true"
          >
            <div
              class="d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <div>
                <v-icon>mdi-tune</v-icon>
                <span class="text_style mx-1" style="letter-spacing: 1px"
                  >Filters</span
                >
              </div>

              <div>
                <v-icon>mdi-menu-down</v-icon>
              </div>
            </div>
          </v-card>
          <!------------------------fliter diloag------------------------------------------>
          <v-dialog v-model="filterDialog" max-width="430" persistent>
            <v-card class="py-5">
              <v-card-title
                class="mb-5 d-flex justify-space-between align-center"
              >
                <div class="text-h5"><b> Filters</b></div>
                <div>
                  <v-btn text depressed class="pa-0" @click="cleanFilter()">
                    <span
                      class="text_style primary--text"
                      style="letter-spacing: 0px"
                      >Clean filters</span
                    >
                  </v-btn>
                  <v-icon class="ml-3" @click="filterDialog = false"
                    >mdi-close</v-icon
                  >
                </div>
              </v-card-title>

              <v-card-text>
                <v-select
                  outlined
                  clearable
                  v-model="filterObj.Visibility"
                  :items="['Show', 'Hide']"
                  dense
                  hide-details
                  label="By Visibility"
                  persistent-hint
                  :menu-props="{ maxHeight: '400' }"
                ></v-select>
                <v-autocomplete
                  clearable
                  outlined
                  class="my-5"
                  :items="submitByNames"
                  v-model="filterObj.SubmittedById"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="By Submitted"
                  multiple
                  persistent-hint
                ></v-autocomplete>
                <v-menu
                  ref="datarangemenu"
                  v-model="datarangemenu"
                  :close-on-content-click="false"
                  :return-value.sync="Renewaldates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      clearable
                      v-model="filterObj.formatDate"
                      label="By Last update"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      dense
                      outlined
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="Renewaldates"
                    no-title
                    scrollable
                    range
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="datarangemenu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.datarangemenu.save(Renewaldates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-select
                  clearable
                  outlined
                  class="my-5"
                  v-model="filterObj.newComment"
                  :items="['Yes', 'No']"
                  :menu-props="{ maxHeight: '400' }"
                  dense
                  hide-details
                  label="By New Comments"
                  persistent-hint
                ></v-select>

                <!---------------------Type-modalitiy model filter-------------------------------->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#646464"
                  outlined
                  depressed
                  class="px-5"
                  text
                  @click="filterDialog = false"
                >
                  <span class="text_style"> Cancel </span>
                </v-btn>
                <v-btn
                  color="primary"
                  class="px-8 ml-2"
                  @click="sendFilters()"
                  depressed
                >
                  <span class="text_style"> Save Filters </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <!------------- section three  data table--------------------->
    <v-card class="mt-6" outlined>
      <v-data-table
        :headers="headers"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :items="blogDataTableOne"
        :hide-default-footer="true"
        :page.sync="page"
        disable-pagination
        :items-per-page-text="itemsPerPage"
      >
        <template v-slot:[`item.indexNo`]="{ index }">
          <b>
            {{
              index +
              `${
                itemsPerPage === "All" ? blogDataTableOne.length : itemsPerPage
              }` *
                (page - 1) +
              1
            }}</b
          >
        </template>

        <template v-slot:[`item.images`]="{ item }">
          <v-card
            flat
            color="transparent"
            style="max-width: fit-content"
            class="pa-1"
          >
            <v-img :src="item.Banner" alt="John" height="50" width="80" />
          </v-card>
        </template>
        <template v-slot:[`item.Title`]="{ item }">
          <span class="table_style_one"> {{ item.Title }} </span>
        </template>
        <template v-slot:[`item.SubmittedByName`]="{ item }">
          <span class="table_style_two"> {{ item.SubmittedByName }} </span>
        </template>
        <template v-slot:[`item.ModifiedDate`]="{ item }">
          <span class="table_style_two">
            {{
              item.ModifiedDate == null
                ? new Date().toISOString().split("T")[0]
                : item.ModifiedDate.split("T")[0]
            }}
          </span>
        </template>
        <template v-slot:[`item.Id`]="{ item }">
          <span class="table_style_two">
            {{ item.Status }}
            <!-- <div v-if="item.SubmittedByName === 'MASTER ACCOUNT'">
              Published
            </div>
            <div v-else>Draft</div> -->
          </span>
        </template>
        <template v-slot:[`item.NewCommentCount`]="{ item }">
          <div class="text-center mx-9">
            <v-card
              color="primary"
              class="comment_card"
              @click="commentsection(item)"
            >
              <span class="text-white" style="font-size: 12px">
                {{ item.NewCommentCount }}
              </span></v-card
            >
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="toggleIsPlaying(item.Id)">
            <v-icon v-if="item.Visibility" color="primary">mdi-eye</v-icon>
            <v-icon v-else>mdi-eye-off</v-icon>
          </v-btn>
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <!-- <v-badge :content="item.countcomment" overlap>
                    <v-icon color="#646464">mdi-message-reply-text</v-icon>
                  </v-badge> -->

              <!-- <v-list class="px-3 pt-1" color="transparent">
                <v-btn depressed color="transparent" block @click="commentsection(item)" class="d-flex justify-start">
                 
                  <v-badge :content="totalblogs" overlap>
                    <v-icon color="#646464">mdi-message-reply-text</v-icon>
                  </v-badge>

                  <span class="ml-4 text_style">Comments </span>
                </v-btn>
              </v-list> -->
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  @click="commentsection(item)"
                  class="d-flex justify-start"
                >
                  <v-badge :content="item.TotalCommentCount" overlap>
                    <v-icon color="#646464">mdi-message-reply-text</v-icon>
                  </v-badge>
                  <span class="ml-4 text_style"> Comments</span>
                </v-btn>
              </v-list>

              <v-list
                class="px-3 pt-1"
                color="transparent"
                v-if="Permission.Edit"
              >
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="SetEditBlog(item.Id)"
                >
                  <v-icon color="#646464">mdi-pencil</v-icon>
                  <span class="ml-4 text_style">Edit</span>
                </v-btn>
              </v-list>
              <v-list
                class="px-3 pt-1"
                color="transparent"
                v-if="Permission.Delete"
              >
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="SetDeleteModel(item.Id)"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style action_dialog">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
          @change="handleItemPerPage()"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        @input="fetchData"
      ></v-pagination>
    </v-card>
    <!---------Delete dialog------------------------>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="DdialogClose()">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="btnloader" @click="DeleteBlog"> <span v-if="btnloader != true">Confirm</span>  
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------------Tooltip Information Dialog-------------------------------->
    <v-dialog v-model="TooltipInformationDialog" persistent max-width="500">
      <v-card class="pa-2">
        <div class="d-flex justify-end">
          <v-icon @click="TooltipInformationDialog = false">mdi-close</v-icon>
        </div>
        <div class="px-6 pb-6 pt-3" style="text-align: justify">
          Articles that are not selected for one of the positions are available
          to select from the dropdown menus. If you want to swap positions, you
          will need to delete the article from its current position, so that you
          may re-select it for a different position.
        </div>
      </v-card>
    </v-dialog>
    <!-----------------------comment dialog start----------------->
    <v-dialog
      v-model="commentdialog"
      max-width="608"
      content-class="elevation-0"
    >
      <v-card flat>
        <Comment @close="close" :commentData="commentarray"></Comment>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Comment from "../../components/bolg/comment.component.vue";
import Organizeblog1Component from "../../components/bolg/organizeblog1.component.vue";
import Organizeblog2Component from "../../components/bolg/organizeblog2.component.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    Organizeblog1Component,
    Organizeblog2Component,
    Comment,
    SuccessToastComponent,
    ErrorToastComponent,
  },
  data() {
    return {
      filtersArray: [],
      NewCommentCount: "1",
      TooltipInformationDialog: false,
      filterDialog: false,
      datarangemenu: false,
      filterLanguages: [
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
        "English",
      ],
      Renewaldates: [],
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      SuccessToast: false,
      ErrorToast: false,
      tableLoader: false, // data-table true or false
      dialog: false,
      isHidden: false,
      commentarray: "",
      commentdialog: false,
      BlogOrganizeM: false,
      btnloader: false,
      editvideodialog: false,
      previewvideodialog2: false,
      NewArticalM: false,
      isPlaying: false,
      search: "",
      DeleteId: 0,
      filterlanguagetList: [
        "Study Group",
        "Public Talk",
        "Expo",
        "Other Event",
      ],
      filterItem: [
        {
          text: "By Date & Date Range",
        },
        {
          text: "By Visibility",
        },
        {
          text: "Submitted By",
        },
        {
          text: "By Language ",
        },
        {
          text: "By New Comments ",
        },
      ],
      headers: [
        { text: "#", value: "indexNo", sortable: false },
        { text: "Header", value: "images", sortable: false },
        { text: "Title", value: "Title" },
        { text: "Submitted by", value: "SubmittedByName" },
        { text: "Last update", value: "ModifiedDate" },
        { text: "Status", value: "Id" },
        { text: "New Comments", value: "NewCommentCount" },

        { text: "", value: "actions", sortable: false },
      ],
      seachTimer: 0,
      blogDataTableOne: [],
      filterObj: {
        formatDate: "",
      },
      isValue: true,
      submitByNames: []
    };
  },
  mounted() {
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Blog"
    );
    this.$store.dispatch("OrganizeGetBlogs")
    // Restore filters from localStorage
    const savedFilters = JSON.parse(localStorage.getItem("blogFilters"));
    if (savedFilters) {
      this.filterObj = savedFilters.filterObj || {};
      this.Renewaldates = savedFilters.Renewaldates || [];
      this.filtersArray = savedFilters.filtersArray || [];
      this.itemsPerPage = savedFilters.itemsPerPage || 10;
      this.page = savedFilters.page || 1;
      
      // If there are saved filters, apply them immediately
      if (this.filtersArray.length > 0 || this.search) {
        this.fetchData();
      } else {
        this.fetchData();
      }
    } else {
      this.fetchData();
    }
  },

  computed: {
    dateRangeText() {
      let firstDate = this.Renewaldates[0];
      let lastDate = this.Renewaldates[1];
      let formatDate =
        moment(firstDate).format("YYYY-MM-DD") +
        " to " +
        moment(lastDate).format("YYYY-MM-DD");
      return formatDate;
    },
    ...mapGetters([
      "GetUserRolePermissions",
      "GetBlogs",
      "GetSiteUser",
      "GetTotalBlogsComment",
    ]),
  },
  watch: {
    dateRangeText() {
      this.filterObj.formatDate = this.dateRangeText;
    },
  },

  beforeRouteEnter(to, from, next) {
    next(() => {
      if (!from.path.startsWith("/blog")) {
        localStorage.removeItem("blogFilters");
      }
    });
  },
  methods: {
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchData();
    },
    sendFilters() {
      this.page = 1
      this.filtersArray = [];
      if (this.filterObj.Visibility && this.filterObj.Visibility.length > 0) {
        this.filtersArray.push({
          Key: "Visibility",
          Value: this.filterObj.Visibility,
        });
      }
      if (
        this.filterObj.SubmittedById &&
        this.filterObj.SubmittedById.length > 0
      ) {
        this.filtersArray.push({
          Key: "SubmittedBy",
          Value: this.filterObj.SubmittedById.join(","),
        });
      }

      if (this.filterObj.newComment && this.filterObj.newComment === "Yes") {
        this.filtersArray.push({
          Key: "ByComment",
          Value: this.filterObj.newComment,
        });
      }
      if (this.filterObj.formatDate) {
        this.filtersArray.push({
          Key: "ByLastUpDate",
          Value: this.filterObj.formatDate,
        });
      }
      // Save filters to localStorage
      localStorage.setItem("blogFilters", JSON.stringify({
        filterObj: this.filterObj,
        Renewaldates: this.Renewaldates,
        filtersArray: this.filtersArray,
        itemsPerPage: this.itemsPerPage,
        page: this.page
      }));
      this.fetchData();
      this.filterDialog = false;
    },
    AddBlog() {
      this.$store.dispatch("ResetRelatedBlog").then(() => {
        this.$router.push({ name: "newartical" });
      });
    },
    cleanFilter() {
      this.filterObj = {};
    },
    DdialogClose() {
      this.dialog = false;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        (this.BlogOrganizeM = false),
          (this.btnloader = false),
          (this.SuccessToast = true);
      }, 2000);
      setTimeout(() => {
        this.SuccessToast = false;
      }, 3000);
    },
    toggleIsPlaying(obj) {
      var data = new FormData();
      data.append("Id", obj);
      this.$store.dispatch("SetVisibility", data).then(() => {
        this.blogDataTableOne = this.blogDataTableOne.map((e) => {
          if (e.Id === obj) {
            e.Visibility = !e.Visibility;
            return e;
          }
          return e;
        });
        this.isPlaying = !this.isPlaying;
      });
    },
    commentsection(item) {
      this.$store
        .dispatch("GetBlogsComments", {
          search: null,
          pageNumber: 1,
          Id: item.Id,
        })
        .then(() => {
          this.blogDataTableOne = this.GetBlogs;
          this.totalBlogs = this.GetTotalBlogsComment;

          this.tableLoader = false;
        });
      this.commentdialog = true;
      this.commentarray = item;
    },

    close() {
      this.commentdialog = false;
      this.SuccessToast = false;
      this.ErrorToast = false;
    },
    SetEditBlog(Id) {
      this.$store.dispatch("GetBlogById", Id).then(() => {
        this.$router.push({ name: "editarticle" });
      });
    },
    SetDeleteModel(Id) {
      this.DeleteId = Id;
      this.dialog = true;
    },
    DeleteBlog() {
      this.btnloader = true;
      this.$store.dispatch("DeleteBlog", this.DeleteId).then((res) => {
        if (res.Status) {
          this.dialog = false;
          this.btnloader = false;
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Deleted Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
          this.fetchData();
        }
      });
    },
    CloseOrganizeBlogs() {
      this.BlogOrganizeM = false;
    },
    searchData(){
      this.page = 1;
      clearTimeout(this.seachTimer);
      this.seachTimer = setTimeout(() => {
        this.fetchData()
      }, 700);
    },
    fetchData() {
      this.page = this.itemsPerPage === "All" ? 1 : this.page;
      var obj = {
        page: this.search ? 1 : this.page,
        pageSize: this.itemsPerPage === "All" ? "10000" : this.itemsPerPage,
        search: this.search,
        filters: JSON.stringify(this.filtersArray) ?? [],
      };
      this.tableLoader = true;
      this.$store.dispatch("GetBlogs", obj).then((res) => {
        this.blogDataTableOne = this.GetBlogs;
        if (this.itemsPerPage !== "All") {
          this.pageCount = Math.ceil(res.totalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
        this.tableLoader = false;
        if (this.pageCount > 1) {
          this.page = res.page;
        } else {
          this.page = 1;
        }
        if(this.isValue){
          this.submitByNames = this.GetBlogs.map((item)=>item.SubmittedByName)
        }
        this.isValue = false
      });
      if(this.GetSiteUser.length == 0){
        this.$store.dispatch("getSiteUser");
      }
    },
  },
};
</script>

<style scoped>
.comment_card {
  width: 25px;
}

.Organize_dialog_parent {
  overflow-x: hidden;
}

.add_orgranize_btn_mobile {
  display: none;
}

@media screen and (max-width: 1030px) {
  .Organize_dialog_one {
    flex: 0 0 100%;
    max-width: 38%;
  }

  .Organize_dialog_two {
    flex: 0 0 50%;
    max-width: 61%;
  }
}

@media screen and (max-width: 800px) {
  .Organize_dialog_one {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .Organize_dialog_two {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media screen and (max-width: 430px) {
  .Organize_dialog_one {
    flex: 0 0 55%;
    max-width: 100%;
  }

  .Organize_dialog_two {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .Organize_dialog_parent {
    overflow-x: auto;
  }

  .add_orgranize_btn_mobile {
    display: block;
  }

  .add_orgranize_btn_destop {
    display: none !important;
  }
}

.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
